import { ReactElement, useMemo } from 'react';
import { useList } from 'react-use';
import short from 'short-uuid';
import styled from 'styled-components';

import { DocumentInvoiceEntity, InvoiceDetail } from '../../../generated-api';
import { buildInvoiceDetail } from '../defs/invoiceResultPageDefinition';
import InvoiceDetailRow, { InvoiceDetailHeader } from './InvoiceDetailRow';

const InvoiceDetailLabel = styled.div`
  margin-bottom: 12px;
`;
const InvoiceDetailSection = styled.div`
  padding: 8px;
  margin-bottom: 24px;
  border: 1px solid #f0f0f0;
  display: grid;
  grid-gap: 8px;
  align-items: center;
  overflow: auto;
  grid-auto-rows: 40px;
`;

type InvoiceDetailFormProps = {
  entity: DocumentInvoiceEntity;
};

function InvoiceDetailForm({ entity }: InvoiceDetailFormProps): ReactElement {
  const details = useMemo(() => {
    if (entity.invoice_details && entity.invoice_details.length > 0) {
      return entity.invoice_details.reduce<Record<string, InvoiceDetail>>((accumulator, current) => {
        accumulator[short.generate()] = current;
        return accumulator;
      }, {});
    } else {
      const initialDetail = buildInvoiceDetail(entity);
      return { [short.generate()]: initialDetail };
    }
  }, [entity]);

  const defaultValue: InvoiceDetail = useMemo(() => {
    return {
      tax_percent: 10,
      amount_without_tax: 0,
      tax_amount: 0,
      amount_with_tax: 0,
      account: '',
    };
  }, []);

  const [rowIds] = useList(Object.keys(details));

  return (
    <>
      <InvoiceDetailLabel>明細</InvoiceDetailLabel>
      <InvoiceDetailSection>
        <InvoiceDetailHeader />
        {rowIds.map((id) => (
          <InvoiceDetailRow key={id} detail={details[id] ?? defaultValue} />
        ))}
      </InvoiceDetailSection>
    </>
  );
}

export default InvoiceDetailForm;
